"use strict";

class AuthPasswordResetCtrl {

	/**
	 * [constructor description]
	 * @param  {[type]} $http [description]
	 * @return {[type]}       [description]
	 */
	constructor ( $http ) {

		let csrftoken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
		let token = document.querySelector('input[name="token"]').getAttribute('value');

		this.$http = $http;

		// Defaults
		this.formdata = {
			email: null,
			password: null,
			password_confirmation: null,
			token: token,
			_token: csrftoken
		};

		this.status = {
			error: false,
			sending: false
		};
	}

	/**
	 * [submit description]
	 * @param  {Boolean} isValid [description]
	 * @return {[type]}          [description]
	 */
	submit ( isValid ) {

		if( !isValid ) {

			return;
		}

		this.status.sending = true;
		this.status.error = false;

		this.$http.post('/password/reset', this.formdata)
			.then(() => {

				// Login successfull!
				this.status.sending = false;
				window.location.reload();
			})
			.catch(() => {

				this.status.error = true;
				this.status.sending = false;
			});
	}
}

AuthPasswordResetCtrl.$inject = ['$http'];

module.exports = AuthPasswordResetCtrl;

